import { createFileRoute } from "@tanstack/react-router";
import BlogIndexPage from "@/pages/BlogIndexPage";
import { pageHead } from "@/lib/site";

export const Route = createFileRoute("/blog/")({
  head: () =>
    pageHead(
      "Blog & Our Stories | Scotty's Land Specialist",
      "Stories from Scotty's Land Specialist on fall cleanup, snow removal, and property work in Highland, Utah.",
      "/blog",
    ),
  component: BlogIndexPage,
});
